var map = {
	"./arrow_down.svg": 306,
	"./edit.svg": 307,
	"./github.svg": 308,
	"./heart.svg": 309,
	"./heart_on.svg": 310,
	"./reply.svg": 311,
	"./tip.svg": 312
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;


//////////////////
// WEBPACK FOOTER
// ./assets/icon !../node_modules/_raw-loader@0.5.1@raw-loader ^\.\/.*\.svg$
// module id = 305
// module chunks = 0